import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const STOPREQUESTOR_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.StopRequestor.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.StopRequestor.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const STOPREQUESTOR_CONFIG = {
  entityName: 'StopRequestor',
  localizationKey: 'Controlling::Entity.StopRequestor',
  fields: STOPREQUESTOR_FIELDS,
  permission: 'ControllingLiquidations.StopRequestors',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
